(function () {
  'use strict';

  var widgetSelector = '#judgeme_product_reviews';
  var otherProductsEngineSelector = '#bz-judgeme-other-products-engine';
  var otherProductsTabId = 'bz-judgeme-tab_all_products';
  var otherProductsPanelId = 'bz-judgeme-other-products-engine';
  var homepageCarouselSelector = '[data-bz-judgeme-home]';
  var writeButtonSelector = '[data-testid="write-review-button"], .jm-action-buttons__button';
  var storeReviewApiUrl = 'https://api.judge.me/api/v1/reviews';
  var observer;
  var observerTimer;
  var sharedReviewOpened = false;

  var reviewPageSize = 3;

  /*
   * Reviews Big Z has muted. The star rating still shows and still counts, and
   * the reviewer name, avatar letter, and words blur out. A review matches on
   * its display name or on a fragment of its body, so add an entry here to mute
   * another one.
   */
  var mutedReviews = [
    { name: 'dick eater', body: 'loved the service a little to much' },
    { name: 'cory mckee', body: 'liked my toes' }
  ];

  var mutedReviewLayouts = [
    {
      item: '.jm-review-item',
      name: '.jm-reviewer-info__name',
      body: '.jm-review-content, .jdgm-review-content__body-content',
      identity: '.jm-reviewer-avatar__initial'
    },
    {
      item: '.jdgm-rev',
      name: '.jdgm-rev__author',
      body: '.jdgm-rev__title, .jdgm-rev__body',
      identity: '.jdgm-rev__icon'
    }
  ];

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollToWidget(event) {
    var widget = document.querySelector(widgetSelector);
    if (!widget) return;

    if (event) event.preventDefault();
    widget.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start'
    });

    var title = widget.querySelector('.jm-review-widget-minimal-header__title');
    if (title) {
      title.setAttribute('tabindex', '-1');
      window.setTimeout(function () {
        title.focus({ preventScroll: true });
      }, prefersReducedMotion() ? 0 : 450);
    }
  }

  function openReviewForm(event) {
    if (event) event.preventDefault();

    var source = event && event.currentTarget;
    var attempts = 0;
    var maxAttempts = 50;
    var widget = document.querySelector(widgetSelector);

    if (source) source.setAttribute('aria-busy', 'true');
    if (widget) {
      widget.scrollIntoView({
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });
    }

    function tryOpen() {
      var button = document.querySelector(writeButtonSelector);
      attempts += 1;

      if (button && /write\s+a\s+review/i.test(button.textContent || '')) {
        if (source) source.removeAttribute('aria-busy');
        button.click();
        return;
      }

      if (attempts < maxAttempts) {
        window.setTimeout(tryOpen, 120);
      } else if (source) {
        source.removeAttribute('aria-busy');
      }
    }

    window.setTimeout(tryOpen, widget && !prefersReducedMotion() ? 240 : 0);
  }

  function customizeWidgetTitle() {
    var title = document.querySelector(widgetSelector + ' .jm-review-widget-minimal-header__title');
    if (title && title.textContent.trim() === 'Customer Reviews') {
      title.textContent = 'Keeper Reviews';
    }
  }

  function reviewTabCount(value) {
    var match = (value || '').match(/\(([\d,]+)\)\s*$/);
    return match ? match[1] : '';
  }

  function scopedReviewTabLabel(label, count) {
    return count ? label + ' (' + count + ')' : label;
  }

  function setNodeText(node, value) {
    if (node && node.textContent.trim() !== value) node.textContent = value;
  }

  function setReviewOptionText(option, value) {
    if (!option) return;
    setNodeText(option.querySelector('[aria-hidden="true"]') || option, value);
  }

  function setLeadingText(node, value) {
    if (!node) return;

    var textNode = Array.prototype.find.call(node.childNodes, function (child) {
      return child.nodeType === Node.TEXT_NODE && child.nodeValue.trim();
    });
    if (!textNode) {
      node.insertBefore(document.createTextNode(value + ' '), node.firstChild);
    } else if (textNode.nodeValue.trim() !== value) {
      textNode.nodeValue = value + ' ';
    }
  }

  function setHiddenAndInert(element, isHidden) {
    if (!element) return;

    element.hidden = isHidden;
    if (isHidden) {
      element.setAttribute('inert', '');
    } else {
      element.removeAttribute('inert');
    }
  }

  function allProductsReviewCount(engine, widget) {
    var legacyHeader = engine && engine.querySelector('.jdgm-all-reviews__header');
    var legacyCount = legacyHeader && legacyHeader.getAttribute('data-number-of-product-reviews');
    if (legacyCount && parseInt(legacyCount, 10) > 0) return legacyCount;

    var engineTab = engine && engine.querySelector('.jdgm-tab[role="tab"]');
    var engineCount = reviewTabCount(engineTab && engineTab.textContent);
    if (engineCount && parseInt(engineCount, 10) > 0) return engineCount;

    var savedCount = widget && widget.getAttribute('data-bz-other-products-review-count');
    if (savedCount && parseInt(savedCount, 10) > 0) return savedCount;

    var allReviewCount = parseInt(widget && widget.getAttribute('data-shop-review-count'), 10);
    var storeCount = parseInt(widget && widget.getAttribute('data-shop-reviews-count'), 10);
    if (Number.isFinite(allReviewCount) && Number.isFinite(storeCount)) {
      return String(Math.max(0, allReviewCount - storeCount));
    }

    return '';
  }

  function allProductsEngineReady(engine, count) {
    if (!engine || !parseInt(count, 10)) return false;

    return Boolean(
      engine.querySelector('.jm-review-item') ||
      engine.querySelector('.jdgm-rev')
    );
  }

  function primaryReviewWidget(widget) {
    return Array.prototype.find.call(widget.children, function (child) {
      return child.classList && child.classList.contains('jm-review-widget');
    }) || widget.querySelector('.jm-review-widget');
  }

  function primaryReviewContent(widget) {
    var primary = primaryReviewWidget(widget);
    if (!primary) return [];

    return [
      primary.querySelector('.jdgm-tablist__content'),
      primary.querySelector('.jm-review-widget__body'),
      primary.querySelector(':scope > .jm-pagination-controls'),
      primary.querySelector(':scope > [data-bz-native-pager-status]'),
      primary.querySelector(':scope > [data-bz-review-pager]')
    ].filter(Boolean);
  }

  function renameSecondaryWidgetIds(engine) {
    if (!engine || !engine.querySelector('.jm-review-widget')) return;

    var idMap = {
      'jdgm-tab_product_reviews': 'bz-judgeme-engine-tab_product_reviews',
      'jdgm-tab_dropdown_product_reviews': 'bz-judgeme-engine-tab_dropdown_product_reviews',
      'jdgm-tabpanel_product_reviews': 'bz-judgeme-engine-tabpanel_product_reviews'
    };

    Object.keys(idMap).forEach(function (oldId) {
      var node = engine.querySelector('#' + oldId);
      if (node) node.id = idMap[oldId];
    });

    engine.querySelectorAll('[aria-controls], [aria-labelledby]').forEach(function (node) {
      ['aria-controls', 'aria-labelledby'].forEach(function (attribute) {
        var currentId = node.getAttribute(attribute);
        if (idMap[currentId]) node.setAttribute(attribute, idMap[currentId]);
      });
    });
  }

  function labelAllProductsReviewSubjects(engine) {
    if (!engine) return;

    engine.querySelectorAll('.jdgm-rev__prod-link-prefix').forEach(function (productPrefix) {
      setNodeText(productPrefix, 'Review for');
    });
  }

  function setReviewTabState(tab, isActive) {
    if (!tab) return;

    tab.classList.toggle('jdgm-tab--active', isActive);
    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    tab.setAttribute('tabindex', isActive ? '0' : '-1');
  }

  function setAllProductsPanelState(widget, isActive) {
    var engine = document.querySelector(otherProductsEngineSelector);
    var customTab = widget.querySelector('#' + otherProductsTabId);
    var productTab = widget.querySelector('#jdgm-tab_product_reviews');
    var storeTab = widget.querySelector('#jdgm-tab_shop_reviews');
    var activeBar = widget.querySelector('.jdgm-tablist__activeBar');

    if (!engine || !customTab) return;

    if (isActive) {
      widget.setAttribute('data-bz-review-scope', 'all-products');
    } else {
      widget.removeAttribute('data-bz-review-scope');
    }

    primaryReviewContent(widget).forEach(function (element) {
      setHiddenAndInert(element, isActive);
    });
    setHiddenAndInert(engine, !isActive);

    setReviewTabState(customTab, isActive);
    if (isActive) {
      setReviewTabState(productTab, false);
      setReviewTabState(storeTab, false);
    }

    if (activeBar) activeBar.hidden = isActive;

    if (isActive) {
      var legacyProductTab = engine.querySelector('.jdgm-subtab__name[data-tabname="product-reviews"]');
      if (legacyProductTab && !legacyProductTab.classList.contains('jdgm--active')) {
        legacyProductTab.click();
      }
      window.dispatchEvent(new Event('scroll'));
    }
  }

  function activateAllProductsReviews(event) {
    if (event) event.preventDefault();

    var widget = event && event.currentTarget.closest(widgetSelector);
    if (!widget) widget = document.querySelector(widgetSelector);
    if (!widget) return;

    setAllProductsPanelState(widget, true);
  }

  function restorePrimaryReviews(event) {
    var widget = event.currentTarget.closest(widgetSelector);
    if (!widget || widget.getAttribute('data-bz-review-scope') !== 'all-products') return;

    setAllProductsPanelState(widget, false);
    setReviewTabState(
      widget.querySelector('#jdgm-tab_product_reviews'),
      event.currentTarget.id === 'jdgm-tab_product_reviews'
    );
    setReviewTabState(
      widget.querySelector('#jdgm-tab_shop_reviews'),
      event.currentTarget.id === 'jdgm-tab_shop_reviews'
    );
  }

  function handleReviewTabKeyboard(event) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    var tabs = Array.prototype.filter.call(
      event.currentTarget.querySelectorAll('.jdgm-tab[role="tab"]'),
      function (tab) {
        return !tab.hidden;
      }
    );
    var currentTab = event.target.closest('.jdgm-tab[role="tab"]');
    var currentIndex = tabs.indexOf(currentTab);
    if (currentIndex < 0 || tabs.length < 2) return;

    var nextIndex = currentIndex;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;

    event.preventDefault();
    event.stopImmediatePropagation();
    tabs[nextIndex].focus({ preventScroll: true });
    tabs[nextIndex].click();
    tabs[nextIndex].scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  function ensureAllProductsReviewsTab() {
    var widget = document.querySelector(widgetSelector);
    var engine = document.querySelector(otherProductsEngineSelector);
    if (!widget || !engine) return;

    var primary = primaryReviewWidget(widget);
    var tabList = primary && primary.querySelector('.jdgm-tablist__list');
    var productTab = primary && primary.querySelector('#jdgm-tab_product_reviews');
    var storeTab = primary && primary.querySelector('#jdgm-tab_shop_reviews');
    var count = allProductsReviewCount(engine, widget);
    if (!primary || !tabList || !productTab || !storeTab || !allProductsEngineReady(engine, count)) return;

    widget.setAttribute('data-bz-other-products-review-count', count);
    engine.classList.add('bz-judgeme-all-products');
    engine.setAttribute('role', 'tabpanel');
    engine.setAttribute('aria-labelledby', otherProductsTabId);
    engine.setAttribute('tabindex', '0');
    engine.setAttribute('aria-busy', 'false');
    renameSecondaryWidgetIds(engine);
    labelAllProductsReviewSubjects(engine);

    if (engine.parentElement !== widget) widget.appendChild(engine);

    var customTab = tabList.querySelector('#' + otherProductsTabId);
    if (!customTab) {
      customTab = document.createElement('button');
      customTab.id = otherProductsTabId;
      customTab.className = 'jdgm-tab bz-judgeme-all-products__tab';
      customTab.type = 'button';
      customTab.setAttribute('role', 'tab');
      customTab.setAttribute('aria-controls', otherProductsPanelId);
      customTab.setAttribute('aria-selected', 'false');
      customTab.setAttribute('tabindex', '-1');
      customTab.addEventListener('click', activateAllProductsReviews);
      tabList.insertBefore(customTab, tabList.querySelector('.jdgm-tablist__activeBar'));
    }
    setNodeText(customTab, scopedReviewTabLabel('All products', count));

    [productTab, storeTab].forEach(function (tab) {
      if (tab.getAttribute('data-bz-all-products-bound') === 'true') return;
      tab.setAttribute('data-bz-all-products-bound', 'true');
      tab.addEventListener('click', restorePrimaryReviews, true);
    });

    if (tabList.getAttribute('data-bz-all-products-keyboard-bound') !== 'true') {
      tabList.setAttribute('data-bz-all-products-keyboard-bound', 'true');
      tabList.addEventListener('keydown', handleReviewTabKeyboard, true);
    }

    setAllProductsPanelState(
      widget,
      widget.getAttribute('data-bz-review-scope') === 'all-products'
    );
  }

  function clarifyWidgetReviewScope() {
    var widget = document.querySelector(widgetSelector);
    if (!widget) return;

    var title = widget.querySelector('.jm-review-widget-minimal-header__title');
    var allReviewCount = parseInt(widget.getAttribute('data-shop-review-count'), 10);
    if (title && Number.isFinite(allReviewCount)) {
      var summary = widget.querySelector('[data-bz-judgeme-total-context]');
      if (!summary) {
        summary = document.createElement('p');
        summary.className = 'bz-judgeme__total-context';
        summary.setAttribute('data-bz-judgeme-total-context', 'true');
      }

      var summaryText = allReviewCount.toLocaleString() +
        (allReviewCount === 1 ? ' review across Big Z' : ' reviews across Big Z');
      setNodeText(summary, summaryText);
      if (title.nextElementSibling !== summary) title.insertAdjacentElement('afterend', summary);
    }

    var productTab = widget.querySelector('#jdgm-tab_product_reviews');
    var storeTab = widget.querySelector('#jdgm-tab_shop_reviews');
    var productOption = widget.querySelector('#jdgm-tab_dropdown_product_reviews');
    var storeOption = widget.querySelector('#jdgm-tab_dropdown_shop_reviews');
    var tabSelect = widget.querySelector('.jdgm-tab-dropdown__select');
    var dropdownLabel = widget.querySelector('.jdgm-tab-dropdown__label');
    var storeCount = widget.getAttribute('data-shop-reviews-count') ||
      reviewTabCount(storeTab && storeTab.textContent) ||
      reviewTabCount(storeOption && storeOption.textContent);
    var currentProductLabel = (productTab && productTab.textContent) ||
      (productOption && productOption.textContent) || '';
    var parsedProductCount = reviewTabCount(currentProductLabel);
    var productCount = widget.getAttribute('data-bz-current-product-review-count');
    if (parsedProductCount && !/^\s*Other products/i.test(currentProductLabel)) {
      productCount = parsedProductCount;
      widget.setAttribute('data-bz-current-product-review-count', productCount);
    }
    if (!productCount) productCount = parsedProductCount;

    var otherProductsHeading = widget.querySelector('.jm-other-products-reviews-text');
    var otherProductsCount = reviewTabCount(otherProductsHeading && otherProductsHeading.textContent) ||
      widget.getAttribute('data-bz-other-products-review-count');
    var parsedStoreCount = parseInt(storeCount, 10);
    if (
      !otherProductsCount &&
      productCount === '0' &&
      Number.isFinite(allReviewCount) &&
      Number.isFinite(parsedStoreCount)
    ) {
      otherProductsCount = String(Math.max(0, allReviewCount - parsedStoreCount));
    }
    if (otherProductsCount) {
      widget.setAttribute('data-bz-other-products-review-count', otherProductsCount);
    }

    var productLabel = scopedReviewTabLabel(
      'This product',
      productCount
    );
    var storeLabel = scopedReviewTabLabel('Store', storeCount);

    setNodeText(productTab, productLabel);
    setNodeText(storeTab, storeLabel);
    setReviewOptionText(productOption, productLabel);
    setReviewOptionText(storeOption, storeLabel);
    setLeadingText(dropdownLabel, tabSelect && tabSelect.value === 'shop_reviews' ? storeLabel : productLabel);
  }

  function clarifyFinalReviewStep() {
    var mediaPage = document.querySelector('.jdgm-write-review-modal__page--share-media.current-page');
    if (!mediaPage) return;

    var intro = mediaPage.querySelector('.jdgm-write-review-modal__intro');
    if (intro && /upload a photo or video to support your review/i.test(intro.textContent || '')) {
      intro.textContent = 'Optional: add a photo or video, or leave this blank.';
    }

    var finalButton = Array.prototype.find.call(
      document.querySelectorAll('.jdgm-write-review-modal__nav-btn-next'),
      function (button) {
        return window.getComputedStyle(button).display !== 'none';
      }
    );
    if (finalButton && /^next$/i.test(finalButton.textContent.trim())) {
      finalButton.textContent = 'Submit review';
    }
  }

  function cleanReviewSubject(value) {
    return (value || '')
      .replace(/\s+EBAY ONLY\s*$/i, '')
      .trim();
  }

  function shortenReviewSubject(value) {
    return cleanReviewSubject(value)
      .replace(/\s*\([^)]*\).*$/, '')
      .trim();
  }

  function labelHomepageReviewSubjects() {
    document.querySelectorAll(homepageCarouselSelector + ' .jdgm-carousel-item__product').forEach(function (product) {
      if (product.querySelector('[data-bz-review-subject]')) return;

      var image = product.querySelector('.jdgm-carousel-item__product-image');
      var fullSubject = cleanReviewSubject(image && image.getAttribute('alt'));
      var shortSubject = shortenReviewSubject(fullSubject);
      if (!image || !fullSubject || !shortSubject) return;

      var label = document.createElement('span');
      label.className = 'bz-reviews__pictured';
      label.setAttribute('data-bz-review-subject', 'true');
      label.setAttribute('aria-label', 'Review for ' + fullSubject);
      label.setAttribute('title', fullSubject);
      label.textContent = 'Pictured: ' + shortSubject;

      image.setAttribute('alt', '');
      image.setAttribute('aria-hidden', 'true');
      product.insertBefore(label, image);
    });
  }

  function reviewDialogFor(element) {
    var section = element && element.closest('.bz-reviews');
    return section && section.querySelector('[data-bz-store-review-dialog]');
  }

  function setReviewFormBusy(form, isBusy) {
    var submit = form.querySelector('[type="submit"]');
    var label = form.querySelector('[data-bz-review-submit-label]');

    if (submit) submit.disabled = isBusy;
    if (label) label.textContent = isBusy ? 'Sending review...' : 'Send review';

    if (isBusy) {
      form.setAttribute('aria-busy', 'true');
    } else {
      form.removeAttribute('aria-busy');
    }
  }

  function setReviewFormStatus(form, message, isError) {
    var status = form.querySelector('[data-bz-store-review-status]');
    if (!status) return;

    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function resetStoreReviewDialog(dialog) {
    var form = dialog.querySelector('[data-bz-store-review-form]');
    var formPanel = dialog.querySelector('[data-bz-store-review-form-panel]');
    var success = dialog.querySelector('[data-bz-store-review-success]');

    if (form && form._bzReviewController) {
      form._bzReviewController.abort();
      form._bzReviewController = null;
    }

    if (form) {
      form.reset();
      setReviewFormBusy(form, false);
      setReviewFormStatus(form, '', false);
    }
    if (formPanel) formPanel.hidden = false;
    if (success) success.hidden = true;
    if (dialog._bzReviewDefaultLabelledby) {
      dialog.setAttribute('aria-labelledby', dialog._bzReviewDefaultLabelledby);
    }
    if (dialog._bzReviewDefaultDescribedby) {
      dialog.setAttribute('aria-describedby', dialog._bzReviewDefaultDescribedby);
    }
  }

  function openStoreReviewDialog(event) {
    var opener = event.currentTarget;
    var dialog = reviewDialogFor(opener);
    if (!dialog) return false;

    if (dialog.open) return true;

    dialog._bzReviewOpener = opener;
    resetStoreReviewDialog(dialog);

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    var title = dialog.querySelector('.bz-review-dialog__title');
    window.setTimeout(function () {
      if (title) title.focus({ preventScroll: true });
    }, 0);

    return true;
  }

  function closeStoreReviewDialog(event) {
    var dialog = reviewDialogFor(event.currentTarget);
    if (!dialog) return;

    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      resetStoreReviewDialog(dialog);
      if (dialog._bzReviewOpener) dialog._bzReviewOpener.focus();
    }
  }

  function showStoreReviewSuccess(form) {
    var dialog = reviewDialogFor(form);
    var formPanel = dialog && dialog.querySelector('[data-bz-store-review-form-panel]');
    var success = dialog && dialog.querySelector('[data-bz-store-review-success]');
    var successTitle = success && success.querySelector('[data-bz-store-review-success-title]');
    var successCopy = success && success.querySelector('p[id]');

    if (formPanel) formPanel.hidden = true;
    if (success) {
      success.hidden = false;
      if (successTitle) {
        dialog.setAttribute('aria-labelledby', successTitle.id);
        successTitle.focus({ preventScroll: true });
      }
      if (successCopy) dialog.setAttribute('aria-describedby', successCopy.id);
    }
  }

  function submitStoreReview(event) {
    event.preventDefault();

    var form = event.currentTarget;
    var honeypot = form.elements.website;
    if (!form.reportValidity()) return;

    if (honeypot && honeypot.value) {
      showStoreReviewSuccess(form);
      return;
    }

    var params = new URLSearchParams();
    params.set('shop_domain', form.getAttribute('data-shop-domain'));
    params.set('platform', 'shopify');
    params.set('name', form.elements.name.value.trim());
    params.set('email', form.elements.email.value.trim());
    params.set('rating', form.elements.rating.value);
    params.set('body', form.elements.body.value.trim());
    params.set('reviewer_name_format', form.elements.reviewer_name_format.value);

    var controller = new AbortController();
    form._bzReviewController = controller;
    setReviewFormStatus(form, '', false);
    setReviewFormBusy(form, true);

    window.fetch(storeReviewApiUrl, {
      method: 'POST',
      body: params,
      signal: controller.signal
    })
      .then(function (response) {
        return response.text().then(function (responseText) {
          if (response.ok) return;

          var error = new Error('Judge.me rejected the review');
          error.status = response.status;
          error.responseText = responseText;
          throw error;
        });
      })
      .then(function () {
        var dialog = reviewDialogFor(form);
        if (form._bzReviewController !== controller || !dialog || !dialog.open) return;
        showStoreReviewSuccess(form);
      })
      .catch(function (error) {
        var dialog = reviewDialogFor(form);
        if (error.name === 'AbortError') return;
        if (form._bzReviewController !== controller || !dialog || !dialog.open) return;

        var message = 'We could not send your review right now. Please try again in a moment.';
        if (error.status === 422) {
          message = 'Judge.me could not accept that review. Please check your email and review text, then try again.';
        } else if (error.status === 429) {
          message = 'Judge.me is receiving too many reviews right now. Please wait a few minutes before trying again.';
        }

        setReviewFormStatus(form, message, true);
      })
      .finally(function () {
        if (form._bzReviewController === controller) {
          form._bzReviewController = null;
          setReviewFormBusy(form, false);
        }
      });
  }

  function storeReviewShareUrl(button) {
    var currentUrl = new URL(window.location.href);
    var previewThemeId = currentUrl.searchParams.get('preview_theme_id');
    var activeTheme = window.Shopify && window.Shopify.theme;
    var isPublicPreviewHost = /\.shopifypreview\.com$/i.test(currentUrl.hostname);
    var isUnpublishedTheme = activeTheme && activeTheme.role && activeTheme.role !== 'main';

    if (!previewThemeId && !isPublicPreviewHost && isUnpublishedTheme && activeTheme.id) {
      previewThemeId = String(activeTheme.id);
    }

    var isThemePreview = Boolean(previewThemeId) || isPublicPreviewHost;
    var canonicalOrigin = button.getAttribute('data-canonical-origin') || currentUrl.origin;
    var shareOrigin = isThemePreview ? currentUrl.origin : canonicalOrigin;
    var shareUrl = new URL(button.getAttribute('data-review-root') || '/', shareOrigin);

    shareUrl.searchParams.set('bz_store_review', '1');
    shareUrl.hash = 'bz-store-review';

    if (previewThemeId) {
      shareUrl.searchParams.set('preview_theme_id', previewThemeId);
      shareUrl.searchParams.set('pb', currentUrl.searchParams.get('pb') || '0');
      if (currentUrl.searchParams.has('_fd')) {
        shareUrl.searchParams.set('_fd', currentUrl.searchParams.get('_fd'));
      }
    }

    return shareUrl.toString();
  }

  function copyText(value) {
    function legacyCopy() {
      return new Promise(function (resolve, reject) {
        var activeElement = document.activeElement;
        var selection = window.getSelection && window.getSelection();
        var ranges = [];
        var textarea = document.createElement('textarea');

        if (selection) {
          for (var index = 0; index < selection.rangeCount; index += 1) {
            ranges.push(selection.getRangeAt(index).cloneRange());
          }
        }

        textarea.value = value;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '0';
        textarea.style.left = '-9999px';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);

        var copied = false;
        try {
          copied = document.execCommand('copy');
        } catch (error) {
          copied = false;
        }

        document.body.removeChild(textarea);

        if (selection) {
          selection.removeAllRanges();
          ranges.forEach(function (range) {
            selection.addRange(range);
          });
        }
        if (activeElement && typeof activeElement.focus === 'function') {
          try {
            activeElement.focus({ preventScroll: true });
          } catch (error) {
            activeElement.focus();
          }
        }

        if (copied) {
          resolve();
        } else {
          reject(new Error('Copy failed'));
        }
      });
    }

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      try {
        return Promise.resolve(navigator.clipboard.writeText(value)).catch(legacyCopy);
      } catch (error) {
        return legacyCopy();
      }
    }

    return legacyCopy();
  }

  function showShareFeedback(button, labelText, statusText, isError) {
    var section = button.closest('.bz-reviews');
    var label = button.querySelector('[data-bz-review-share-label]');
    var status = section && section.querySelector('[data-bz-review-share-status]');

    window.clearTimeout(button._bzShareTimer);
    if (label) label.textContent = labelText;
    if (status) status.textContent = statusText;
    button.classList.toggle('is-error', Boolean(isError));
    button.classList.toggle('is-success', !isError);

    button._bzShareTimer = window.setTimeout(function () {
      if (label) label.textContent = 'Copy link';
      if (status) status.textContent = '';
      button.classList.remove('is-error', 'is-success');
    }, 2200);
  }

  function copyStoreReviewLink(button, shareUrl) {
    return copyText(shareUrl).then(function () {
      showShareFeedback(button, 'Copied', 'Review link copied.', false);
    });
  }

  function copyStoreReviewFormLink(event) {
    var button = event.currentTarget;
    if (button.getAttribute('aria-busy') === 'true') return;

    var shareUrl = storeReviewShareUrl(button);

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    copyStoreReviewLink(button, shareUrl)
      .catch(function () {
        showShareFeedback(button, 'Try again', 'The review link could not be copied. Please try again.', true);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      });
  }

  function openSharedStoreReview() {
    if (sharedReviewOpened) return;

    var currentUrl;
    try {
      currentUrl = new URL(window.location.href);
    } catch (error) {
      return;
    }
    if (
      currentUrl.searchParams.get('bz_store_review') !== '1' &&
      currentUrl.hash !== '#bz-store-review'
    ) {
      return;
    }

    var opener = document.querySelector('.bz-reviews [data-bz-store-review-open]');
    var dialog = opener && reviewDialogFor(opener);
    if (!opener || !dialog) return;

    if (dialog.open || openStoreReviewDialog({ currentTarget: opener })) {
      sharedReviewOpened = true;
      currentUrl.searchParams.delete('bz_store_review');
      currentUrl.hash = 'bzn-reviews';
      try {
        window.history.replaceState(window.history.state, '', currentUrl.toString());
      } catch (error) {
        /* The in-memory guard still prevents repeat opening. */
      }
    }
  }

  function bindStoreReviewForm() {
    document.querySelectorAll('[data-bz-store-review-open]:not([data-bz-review-bound])').forEach(function (button) {
      button.setAttribute('data-bz-review-bound', 'true');
      button.addEventListener('click', openStoreReviewDialog);
    });

    document.querySelectorAll('[data-bz-store-review-share]:not([data-bz-review-bound])').forEach(function (button) {
      button.setAttribute('data-bz-review-bound', 'true');
      button.disabled = false;
      button.addEventListener('click', copyStoreReviewFormLink);
    });

    document.querySelectorAll('[data-bz-store-review-close]:not([data-bz-review-bound])').forEach(function (button) {
      button.setAttribute('data-bz-review-bound', 'true');
      button.addEventListener('click', closeStoreReviewDialog);
    });

    document.querySelectorAll('[data-bz-store-review-form]:not([data-bz-review-bound])').forEach(function (form) {
      form.setAttribute('data-bz-review-bound', 'true');
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = false;
      form.addEventListener('submit', submitStoreReview);
    });

    document.querySelectorAll('[data-bz-store-review-dialog]:not([data-bz-review-bound])').forEach(function (dialog) {
      dialog.setAttribute('data-bz-review-bound', 'true');
      dialog._bzReviewDefaultLabelledby = dialog.getAttribute('aria-labelledby');
      dialog._bzReviewDefaultDescribedby = dialog.getAttribute('aria-describedby');
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog && dialog.open) dialog.close();
      });
      dialog.addEventListener('close', function () {
        var opener = dialog._bzReviewOpener;
        resetStoreReviewDialog(dialog);
        if (opener && document.contains(opener)) opener.focus();
      });
    });

    openSharedStoreReview();
  }

  function normalizeReviewText(value) {
    return (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function isMutedReview(name, body) {
    var reviewerName = normalizeReviewText(name);
    var reviewBody = normalizeReviewText(body);

    return mutedReviews.some(function (entry) {
      if (entry.name && reviewerName && reviewerName === entry.name) return true;
      return Boolean(entry.body && reviewBody && reviewBody.indexOf(entry.body) !== -1);
    });
  }

  function outermostNodes(nodeList) {
    var nodes = Array.prototype.slice.call(nodeList);

    return nodes.filter(function (node) {
      return !nodes.some(function (other) {
        return other !== node && other.contains(node);
      });
    });
  }

  function setReviewNodeMuted(node, isMuted) {
    if (!node) return;

    node.classList.toggle('bz-review-muted', isMuted);
    if (isMuted) {
      node.setAttribute('aria-hidden', 'true');
    } else if (node.getAttribute('aria-hidden') === 'true') {
      node.removeAttribute('aria-hidden');
    }
  }

  function setMutedReviewNote(review, isMuted) {
    var note = review.querySelector('[data-bz-review-muted-note]');

    if (!isMuted) {
      if (note) note.remove();
      return;
    }
    if (note) return;

    note = document.createElement('span');
    note.className = 'bz-review-muted__note';
    note.setAttribute('data-bz-review-muted-note', 'true');
    note.textContent = 'Big Z has hidden this reviewer and their comment. The rating still counts.';
    review.insertBefore(note, review.firstChild);
  }

  function muteFlaggedReviews() {
    mutedReviewLayouts.forEach(function (layout) {
      document.querySelectorAll(layout.item).forEach(function (review) {
        var nameNode = review.querySelector(layout.name);
        var bodyNodes = outermostNodes(review.querySelectorAll(layout.body));
        var bodyText = bodyNodes
          .map(function (node) {
            return node.textContent;
          })
          .join(' ');
        var isMuted = isMutedReview(nameNode && nameNode.textContent, bodyText);

        review.classList.toggle('bz-review-muted-card', isMuted);
        setReviewNodeMuted(nameNode, isMuted);
        setReviewNodeMuted(review.querySelector(layout.identity), isMuted);
        bodyNodes.forEach(function (node) {
          setReviewNodeMuted(node, isMuted);
        });
        setMutedReviewNote(review, isMuted);
      });
    });
  }

  /*
   * Judge.me hands the theme every review for a tab in one go, so the theme
   * pages all three tabs itself and they share one control. If Judge.me ever
   * starts paging a list again, its own control comes back and the theme stands
   * aside rather than stacking a second pager on top of it.
   */
  var paginatedReviewSources = [
    {
      itemClass: 'jm-review-item',
      list: function () {
        return Array.prototype.find.call(
          document.querySelectorAll(widgetSelector + ' .jdgm-review-list'),
          function (list) {
            return !list.closest(otherProductsEngineSelector);
          }
        );
      },
      container: function (list) {
        return list.closest('.jm-review-widget') || list.parentElement;
      },
      judgemePaged: function (list) {
        var widget = list.closest('.jm-review-widget');
        return Boolean(widget && widget.querySelector('.jm-pagination-controls'));
      }
    },
    {
      itemClass: 'jdgm-rev',
      list: function () {
        return document.querySelector(otherProductsEngineSelector + ' .jdgm-all-reviews__body');
      },
      container: function (list) {
        return list.parentElement;
      }
    }
  ];

  function reviewListItems(list, itemClass) {
    return Array.prototype.filter.call(list.children, function (child) {
      return child.classList && child.classList.contains(itemClass);
    });
  }

  function currentReviewPage(list, pageCount) {
    var page = parseInt(list.getAttribute('data-bz-review-page'), 10);
    if (!Number.isFinite(page)) page = 1;

    return Math.min(Math.max(page, 1), pageCount);
  }

  function reviewPageNumbers(current, pageCount) {
    var wanted = [1, current - 1, current, current + 1, pageCount];

    return wanted
      .filter(function (page, index) {
        return page >= 1 && page <= pageCount && wanted.indexOf(page) === index;
      })
      .sort(function (a, b) {
        return a - b;
      });
  }

  function reviewPagerButton(label, attribute, value) {
    var button = document.createElement('button');

    button.type = 'button';
    button.className = 'bz-review-pager__btn';
    button.setAttribute(attribute, String(value));
    button.textContent = label;

    return button;
  }

  function reviewPagerStepButton(label, step, isDisabled) {
    var button = reviewPagerButton(label, 'data-bz-review-page-step', step);

    button.classList.add('bz-review-pager__btn--step');
    button.disabled = isDisabled;

    return button;
  }

  function reviewPagerPageButton(page, isCurrent) {
    var button = reviewPagerButton(String(page), 'data-bz-review-page-go', page);

    button.setAttribute('aria-label', 'Page ' + page);
    if (isCurrent) {
      button.classList.add('bz-review-pager__btn--current');
      button.setAttribute('aria-current', 'true');
    }

    return button;
  }

  function reviewPagerGap() {
    var gap = document.createElement('span');

    gap.className = 'bz-review-pager__gap';
    gap.setAttribute('aria-hidden', 'true');
    gap.textContent = '…';

    return gap;
  }

  /*
   * Changing page should not move the page. The reviews above the buttons
   * change height, and Judge.me's own pager scrolls its widget to the top of
   * the viewport, so both controls get pinned: whatever the list does, the
   * buttons stay where the reader left them. A deliberate scroll wins.
   */
  function reviewPagerAnchor(node) {
    var top = node && node.isConnected ? node.getBoundingClientRect().top : null;

    return function () {
      if (top === null || !node.isConnected) return;

      var drift = node.getBoundingClientRect().top - top;
      if (Math.abs(drift) >= 1) window.scrollBy(0, drift);
    };
  }

  function holdReviewPagerStill(node, frames) {
    var settle = reviewPagerAnchor(node);
    var released = false;

    function release() {
      if (released) return;
      released = true;

      window.removeEventListener('scroll', settle);
      ['wheel', 'touchstart', 'keydown'].forEach(function (name) {
        window.removeEventListener(name, release);
      });
    }

    window.addEventListener('scroll', settle);
    ['wheel', 'touchstart', 'keydown'].forEach(function (name) {
      window.addEventListener(name, release, { passive: true });
    });

    (function tick(remaining) {
      if (released) return;

      settle();
      if (remaining <= 0) {
        release();
        return;
      }

      window.requestAnimationFrame(function () {
        tick(remaining - 1);
      });
    })(frames);
  }

  function holdNativeReviewPagerStill(event) {
    if (!event.target.closest('.jm-pagination-controls__button')) return;

    holdReviewPagerStill(event.currentTarget, 75);
  }

  function buildReviewPager(list, itemClass) {
    var pager = document.createElement('nav');
    var status = document.createElement('p');
    var buttons = document.createElement('div');

    pager.className = 'bz-review-pager';
    pager.setAttribute('data-bz-review-pager', 'true');
    pager.setAttribute('aria-label', 'Review pages');
    pager.bzReviewList = list;
    pager.bzReviewItemClass = itemClass;

    status.className = 'bz-review-pager__status';
    status.setAttribute('data-bz-review-pager-status', 'true');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');

    buttons.className = 'bz-review-pager__list';
    buttons.setAttribute('data-bz-review-pager-list', 'true');

    pager.appendChild(status);
    pager.appendChild(buttons);
    pager.addEventListener('click', handleReviewPagerClick);

    return pager;
  }

  function mountReviewPager(container, pager) {
    container.querySelectorAll('[data-bz-review-pager]').forEach(function (existing) {
      if (existing !== pager) existing.remove();
    });
    if (pager.parentElement !== container) container.appendChild(pager);
  }

  function clearReviewPagers(container) {
    container.querySelectorAll('[data-bz-review-pager]').forEach(function (pager) {
      pager.remove();
    });
  }

  function renderReviewPager(pager, current, pageCount, total) {
    var firstShown = (current - 1) * reviewPageSize + 1;
    var lastShown = Math.min(current * reviewPageSize, total);
    var signature = current + '/' + pageCount + '/' + total;

    setNodeText(
      pager.querySelector('[data-bz-review-pager-status]'),
      'Showing ' + firstShown + ' to ' + lastShown + ' of ' + total + ' reviews'
    );

    if (pager.getAttribute('data-bz-review-pager-signature') === signature) return;
    pager.setAttribute('data-bz-review-pager-signature', signature);

    var buttons = pager.querySelector('[data-bz-review-pager-list]');
    buttons.textContent = '';
    buttons.appendChild(reviewPagerStepButton('Previous', -1, current === 1));
    reviewPageNumbers(current, pageCount).forEach(function (page, index, pages) {
      if (index && page - pages[index - 1] > 1) buttons.appendChild(reviewPagerGap());
      buttons.appendChild(reviewPagerPageButton(page, page === current));
    });
    buttons.appendChild(reviewPagerStepButton('Next', 1, current === pageCount));
  }

  function paginateReviewList(source) {
    var list = source.list();
    if (!list) return;

    var container = source.container(list);
    if (!container) return;

    var items = reviewListItems(list, source.itemClass);
    var judgemePaged = Boolean(source.judgemePaged && source.judgemePaged(list));

    if (judgemePaged || items.length <= reviewPageSize) {
      items.forEach(function (item) {
        item.hidden = false;
      });
      list.removeAttribute('data-bz-review-page');
      clearReviewPagers(container);
      return;
    }

    var pageCount = Math.ceil(items.length / reviewPageSize);
    var current = currentReviewPage(list, pageCount);

    list.setAttribute('data-bz-review-page', String(current));
    items.forEach(function (item, index) {
      item.hidden = Math.floor(index / reviewPageSize) + 1 !== current;
    });

    var pager = list.bzReviewPager;
    if (!pager || !pager.isConnected) {
      pager = buildReviewPager(list, source.itemClass);
      list.bzReviewPager = pager;
    }

    mountReviewPager(container, pager);
    renderReviewPager(pager, current, pageCount, items.length);
  }

  /*
   * Judge.me draws its own control on the two tabs it pages itself. The theme
   * gives it the same face as its own pager: the words rather than chevrons,
   * and the same "Showing x to y" line above it. Page size comes from Judge.me,
   * so the count is read back off its buttons instead of being assumed.
   */
  function activeReviewTabTotal(widget) {
    var activeTab = widget.querySelector('.jdgm-tab[role="tab"][aria-selected="true"]');
    var count = reviewTabCount(activeTab && activeTab.textContent).replace(/,/g, '');

    return parseInt(count, 10);
  }

  function nativeReviewPagerState(nav) {
    var state = { current: 0, pageCount: 0 };

    nav.querySelectorAll('.jm-pagination-controls__button--page').forEach(function (button) {
      var page = parseInt(button.textContent, 10);
      if (!Number.isFinite(page)) return;

      if (page > state.pageCount) state.pageCount = page;
      if (button.getAttribute('aria-current') === 'page') state.current = page;
    });

    return state;
  }

  function dressNativeReviewPager() {
    var widget = document.querySelector(widgetSelector);
    if (!widget) return;

    var primary = primaryReviewWidget(widget);
    if (!primary) return;

    var nav = primary.querySelector(':scope > .jm-pagination-controls');
    var status = primary.querySelector(':scope > [data-bz-native-pager-status]');
    var total = activeReviewTabTotal(widget);
    var state = nav ? nativeReviewPagerState(nav) : null;

    if (nav && nav.getAttribute('data-bz-pager-held') !== 'true') {
      nav.setAttribute('data-bz-pager-held', 'true');
      nav.addEventListener('click', holdNativeReviewPagerStill);
    }

    if (!nav || !state.current || !state.pageCount || !Number.isFinite(total)) {
      if (status) status.remove();
      return;
    }

    var perPage = Math.ceil(total / state.pageCount);
    var firstShown = (state.current - 1) * perPage + 1;
    var lastShown = Math.min(state.current * perPage, total);

    if (!status) {
      status = document.createElement('p');
      status.className = 'bz-review-pager__status';
      status.setAttribute('data-bz-native-pager-status', 'true');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      nav.insertAdjacentElement('beforebegin', status);
    }

    setNodeText(
      status,
      'Showing ' + firstShown + ' to ' + lastShown + ' of ' + total + ' reviews'
    );
  }

  function ensureReviewPagination() {
    paginatedReviewSources.forEach(paginateReviewList);
  }

  function handleReviewPagerClick(event) {
    var control = event.target.closest('[data-bz-review-page-go], [data-bz-review-page-step]');
    if (!control) return;

    var pager = event.currentTarget;
    var list = pager.bzReviewList;
    if (!list || !list.isConnected) return;

    event.preventDefault();

    var items = reviewListItems(list, pager.bzReviewItemClass);
    var pageCount = Math.max(1, Math.ceil(items.length / reviewPageSize));
    var current = currentReviewPage(list, pageCount);
    var step = parseInt(control.getAttribute('data-bz-review-page-step'), 10);
    var target = Number.isFinite(step)
      ? current + step
      : parseInt(control.getAttribute('data-bz-review-page-go'), 10);

    if (!Number.isFinite(target)) return;

    target = Math.min(Math.max(target, 1), pageCount);
    if (target === current) return;

    var settle = reviewPagerAnchor(pager);

    list.setAttribute('data-bz-review-page', String(target));
    ensureReviewPagination();
    settle();

    var nextFocus = Number.isFinite(step)
      ? pager.querySelector('[data-bz-review-page-step="' + step + '"]:not([disabled])')
      : null;
    if (!nextFocus) {
      nextFocus = pager.querySelector('[data-bz-review-page-go="' + target + '"]');
    }
    if (nextFocus) nextFocus.focus({ preventScroll: true });
  }

  function bindControls() {
    document.querySelectorAll('[data-bz-review-scroll]:not([data-bz-review-bound])').forEach(function (link) {
      link.setAttribute('data-bz-review-bound', 'true');
      link.addEventListener('click', scrollToWidget);
    });

    document.querySelectorAll('[data-bz-review-write]:not([data-bz-review-bound])').forEach(function (link) {
      link.setAttribute('data-bz-review-bound', 'true');
      link.addEventListener('click', openReviewForm);
    });

    customizeWidgetTitle();
    clarifyWidgetReviewScope();
    ensureAllProductsReviewsTab();
    muteFlaggedReviews();
    ensureReviewPagination();
    dressNativeReviewPager();
    clarifyFinalReviewStep();
    labelHomepageReviewSubjects();
    bindStoreReviewForm();
  }

  function start() {
    bindControls();

    if (
      !document.querySelector('[data-bz-review-entry]') &&
      !document.querySelector(widgetSelector) &&
      !document.querySelector(homepageCarouselSelector) &&
      !document.querySelector('[data-bz-store-review-dialog]')
    ) {
      return;
    }

    observer = new MutationObserver(function () {
      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(bindControls, 80);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', bindControls);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
